<template>
  <div
    class="dashboard-information"
    v-loading="loading"
    :class="{ none: !callingInfo }"
  >
    <div>
      <template v-if="callingInfo">
        <div class="call">
          <div class="sub-cont">
            <div class="title">{{ inout === "in" ? "来" : "去" }}电信息</div>
            <div>
              <div class="field">
                <div class="label">来电号码</div>
                <div class="text">
                  {{ Utils.formatPhoneNumber(callNumber) }}
                </div>
              </div>
              <div class="field">
                <div class="label">归属地</div>
                <div class="text">
                  <template v-if="callingInfo.region.Province"
                    >{{ callingInfo.region.Province }} -
                    {{ callingInfo.region.City }}</template
                  >
                  <template>未知</template>
                </div>
              </div>
              <div class="field">
                <div class="label">
                  {{ inout === "in" ? "来" : "去" }}电人员
                </div>
                <div class="text">{{ phoneName }}</div>
              </div>
              <div class="field">
                <div class="label">来电身份</div>
                <div class="text">{{ identity | identityFilter }}</div>
              </div>
            </div>
          </div>
          <div class="gap"></div>
          <div class="sub-cont">
            <div class="title">通话记录</div>
            <div>
              <p>{{ phoneName }}</p>
              <i class="iconfont iconlianxiren success"></i>
              <p>
                今日第
                <i>{{ callingInfo.recordsCount || 1 }}</i
                >次来电
              </p>
            </div>
          </div>
          <div class="gap"></div>
          <div class="sub-cont">
            <div class="title none"></div>
            <div>
              <ul>
                <li v-for="item in callingInfo.records || []">
                  <div>
                    {{ Utils.dateFormat(item.startTime, "MM-DD HH:mm:ss") }}
                  </div>
                  <div>
                    呼{{
                      item.contactType === 0
                        ? "入"
                        : item.contactType === 1
                        ? "出"
                        : "未知"
                    }}入
                  </div>
                  <div>{{ getFormattedTime(item.duration || 0) }}</div>
                  <!--<div>-->
                  <!--<a href="javascript:">查看工单</a>-->
                  <!--<a href="javascript:">查看订单</a>-->
                  <!--</div>-->
                </li>
              </ul>
            </div>
          </div>
          <div class="gap"></div>
          <div class="sub-cont">
            <div class="title">关联老人</div>
            <div>
              <el-radio-group v-model="theChooseOldName" size="medium">
                <el-radio-button
                  v-for="(item, idx) in phoneContactOlder"
                  :key="idx"
                  :label="item.name"
                ></el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="person">
          <div class="sub-cont">
            <div class="title">老人信息</div>
            <div>
              <div class="field">
                <div class="label">关联老人</div>
                <div class="text goOlder" @click="goOlderDetail">
                  {{ callingInfo.person.name }}({{
                    callingInfo.person.gender === true ? "男" : "女"
                  }}, {{ callingInfo.person.age }}岁)
                </div>
              </div>
              <div class="field">
                <div class="label">老人类型</div>
                <div class="text">
                  {{ getNameOfOldManType(callingInfo.person.type) }}
                </div>
              </div>
              <div class="field">
                <div class="label">所在社区</div>
                <div class="text">{{ callingInfo.person.community }}</div>
              </div>
            </div>
          </div>
          <div class="gap"></div>
          <div class="sub-cont">
            <div class="title">联系人信息</div>
            <div>
              <ul>
                <li
                  class="field"
                  v-for="(item, idx) in callingInfo.contacts"
                  :key="item.gid"
                >
                  <div class="label">联系人{{ idx + 1 }}</div>
                  <div class="text">
                    {{ item.name }}, {{ item.relationship }},
                    {{ Utils.formatPhoneNumber(item.phone) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="orders">
          <div class="sub-cont">
            <div class="title">订单信息</div>
            <div style="max-width: 1200px">
              <baseTableOne
                style="width: 100%; min-width: 1000px"
                :columns="allTableObj.columns"
                :currentObj="allTableObj.currentObj"
                :showPage="allTableObj.showPage"
                :options="allTableObj.options"
                :loadObj="allTableObj.loadObj"
                :operationColumn="allTableObj.operationColumn"
                @dataSizeChange="handleSizeChange($event, allTableObj)"
                @dataCurrentChange="handleCurrentChange($event, allTableObj)"
              ></baseTableOne>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Promise from 'promise'
import qs from 'qs'
import { getServiceOrder } from "@/services/all-api.js"
export default {
  filters: {
    identityFilter(val) {
      switch (val) {
        case 'TheOld':
          return '老人本人'
        case 'TheOldContact':
          return '老人联系人'
      }
    }
  },
  props: {
    callNumber: {
      default() {
        return null
      }
    },
    // 是来电 in 还是 去电
    inout: {
      default() {
        return 'in'
      }
    }
  },
  data() {
    return {
      phoneName: null,
      identity: null,
      theChooseOldName: null,
      phoneContactOlder: [],
      loading: false,
      callingInfo: null,
      orders: [],
      allTableObj: {
        showPage: true,
        columns: [
          {
            prop: "num",
            label: "#",
            width: "60px",
            align: "center"
          },
          {
            prop: "createTime",
            label: "下单时间",
            width: "160px",
            align: "center"
          },
          {
            prop: "theOldName",
            label: "服务对象",
            align: "center"
          },
          {
            prop: "payment",
            label: "金额",
            align: "center"
          },
          {
            prop: "personPayment",
            label: "个人账户自付",
            align: "center"
          },
          {
            prop: "grantPayment",
            label: "基础补助扣款",
            align: "center"
          },
          // {
          //   prop: "fundPayment",
          //   label: "孝善基金扣款",
          //   align: "center"
          // },
          {
            prop: "servicePersonalName",
            label: "服务人员",
            align: "center"
          },
          {
            prop: "serviceProviderName",
            label: "服务商名称",
            align: "center"
          },
          {
            prop: "status",
            label: "订单状态",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: params.row.stauts === 5 ? "" : "color:#67C23A"
                },
                params.row.status === 0
                  ? "待支付"
                  : params.row.status === 1
                    ? "已支付"
                    : params.row.status === 2
                      ? "待分派"
                      : params.row.status === 3
                        ? "已派单"
                        : params.row.status === 4
                          ? "服务中"
                          : params.row.status === 5
                            ? "已完成"
                            : params.row.status === 6
                              ? "待评价"
                              : params.row.status === 7
                                ? "已评价"
                                : params.row.status === 8
                                  ? "已关闭"
                                  : ""
              );
            }
          },
        ],
        currentObj: {
          dataList: [],
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead,
          tableHeight: "320px"
        },
        loadObj: {
          isLoading: false
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "200px",
          btns: [
            {
              size: "mini",
              icon: "el-icon-tickets",
              type: "text",
              style: "font-size:16px",
              disabled: false,
              method: (index, row) => {
                this.handleDetail(index, row);
              }
            },
          ]
        },
        currentTab: "all",
        searchObj: {}
      }
    }
  },
  watch: {
    theChooseOldName(i) {
      this.phoneContactOlder.map(item => {
        if (item.name === i) {
          this.$emit("personPhone", item.phone);
          this.loadOneOld(item.gid)
          return
        }
      })
    },
    callNumber: {
      immediate: true,
      handler(nv, ov) {
        console.log("callNumber::nv:" + nv);
        console.log("callNumber::ov:" + ov);
        // if(window.callByAli){
        if (!nv) {
          this.callingInfo = null
          this.loading = false
        } else if (nv !== ov) {
          this.loadData()
        }
        // }else{
        //   this.loadData()
        // }

      }
    },
    '$store.state.callInfo.oid': {
      handler(nv, ov) {
        if (ov && !nv) {
          this.$confirm('是否跳转填写工单详情？').then(() => {
            this.routeTo({ path: '/orders/workorder/detail', query: { oid: ov } })
          })
        }
      }

    },
    '$store.state.callState': {
      handler(nv, ov) {
        console.log(nv + ":::" + ov);
        if (nv == 9 && ov == 6) {
          this.Service.call('workorder', 'POST', qs.stringify({
            status: 2,
            type: 1, //工单类型 0-其他；1-电话咨询；2-订单工单；3-主动外呼；4-投诉；5-报警工单；6-紧急呼叫
            title: "坐席工单",
            userid: this.callingInfo.person.gid,
            userName: this.callingInfo.person.name,
            cCContactId: JSON.parse(localStorage.getItem('initialInfo')).instanceId //通话id
          }), null, null, null, 'application/x-www-form-urlencoded').then(() => {

          })
        }
        if (nv == 10 && ov == 8) {
          this.Service.call('workorder', 'POST', qs.stringify({
            status: 2,
            type: 3, //工单类型 0-其他；1-电话咨询；2-订单工单；3-主动外呼；4-投诉；5-报警工单；6-紧急呼叫
            title: "坐席工单",
            userid: this.callingInfo.person.gid,
            userName: this.callingInfo.person.name,
            cCContactId: JSON.parse(localStorage.getItem('initialInfo')).instanceId //通话id
          }), null, null, null, 'application/x-www-form-urlencoded').then(res => {
            this.$store.commit('setCallInfo', { ...this.$store.state.callInfo, oid: res._id.$oid });
          })
        }
        if (nv == "ALERTING" && ov == "OCCUPY") {
          // console.log("this.callingInfo::::"+JSON.stringify(this.callingInfo))
          // console.log(11111111);
          //  console.log({
          //     status: 2,
          //     type: 1, //工单类型 0-其他；1-电话咨询；2-订单工单；3-主动外呼；4-投诉；5-报警工单；6-紧急呼叫
          //     userid: this.callingInfo.person.gid,
          //     userName: this.callingInfo.person.name,
          //     cCContactId: JSON.parse(localStorage.getItem('initialInfo')).instanceId //通话id
          // });
          // this.Service.call('workorder', 'POST', qs.stringify({
          //     status: 2,
          //     type: 1, //工单类型 0-其他；1-电话咨询；2-订单工单；3-主动外呼；4-投诉；5-报警工单；6-紧急呼叫
          //     userid: this.callingInfo.person.gid,
          //     userName: this.callingInfo.person.name,
          //     cCContactId: JSON.parse(localStorage.getItem('initialInfo')).instanceId //通话id
          // }), null, null, null, 'application/x-www-form-urlencoded').then(() => {

          // })
        }
      }
    },
  },
  methods: {
    async loadData() {
      let tel = this.callNumber
      this.loading = true
      let callingInfo = {
        region: {},
        person: {},
        contacts: [],
        records: [],
        recordsCount: 1
      }
      let date = new Date()
      try {
        console.log("tel::" + tel);
        console.log("this.phoneContactOlder1:" + JSON.stringify(this.phoneContactOlder));
        await Promise.all([
          // 来电信息
          this.Service.call('phonenumber/numberRegionInfo', 'GET', { number: tel }).then(data => {
            callingInfo.region = data || {}
          }).catch(() => { }),
          // 老人详细信息
          this.Service.call('theold/callcenter/byphone', 'GET', { phone: tel }).then(data => {
            this.phoneName = data.name
            if (data && data.theOlds.length > 0) {
              this.identity = data.relationship
              // this.phoneContactOlder = [...data.theOlds];
              for (let a of data.theOlds) {
                let same = false;
                for (let b of this.phoneContactOlder) {
                  if (a.idCard == b.idCard) {
                    same = true;
                    break;
                  }
                }
                if (!same) {
                  this.phoneContactOlder.push(a);
                }
              }
              console.log("this.phoneContactOlder2:" + JSON.stringify(this.phoneContactOlder));
              callingInfo.person = data.theOlds[0] || {}
              return new Promise.resolve(data.theOlds[0].gid)
            }
          }).then((gid) => {
            this.loadOneOld(gid)
          }),
          // 通话记录
          this.Service.call('callRecord/list', 'GET', { criteria: tel, size: 5, index: 0 }).then(data => {
            callingInfo.records = data && data.data || []
          }).catch(() => { }),
          // 当天通话条数
          this.Service.call('callRecord/list', 'GET', { criteria: tel, size: 1, index: 0, startTime: this.Utils.dateFormat(date, 'YYYY-MM-DD 00:00:00'), endTime: this.Utils.dateFormat(date, 'YYYY-MM-DD 23:59:59') }).then(data => {
            callingInfo.recordsCount = data && data.total + 1 || 1
          }).catch(() => { }),
        ]).finally(() => {
          this.loading = false
          this.callingInfo = callingInfo;
          if (!window.callByAli) {
            console.log("callingInfo::::" + JSON.stringify(callingInfo))
            this.Service.call('workorder', 'POST', qs.stringify({
              status: 2,
              type: 1, //工单类型 0-其他；1-电话咨询；2-订单工单；3-主动外呼；4-投诉；5-报警工单；6-紧急呼叫
              userid: callingInfo.person.gid,
              userName: callingInfo.person.name,
              cCContactId: JSON.parse(localStorage.getItem('initialInfo')).instanceId //通话id
            }), null, null, null, 'application/x-www-form-urlencoded').then(() => {

            })
          }
        });
        await this.$nextTick(() => {
          this.theChooseOldName = this.phoneContactOlder[0].name
        })
      }
      catch (err) {

      }
    },
    loadOneOld(gid) {
      //订单信息
      getServiceOrder({ index: 0, size: 10, theOldGid: gid, type: 1 }).then(res => {
        const temp = {
          dataList: res.data.data.map((item, idx) => ({
            num: res.data.index * res.data.size + idx + 1,
            ...item,
          })),
          currentPage: res.data.index + 1,
          total: res.data.total,
          pageSize: res.data.size
        }
        this.allTableObj.currentObj = { ...temp }
        // 联系人信息
        this.Service.call('usercontact', 'GET', { gid: gid }).then(data => {
          this.callingInfo.contacts = data || []
          this.Service.call('theold/detail', 'GET', { gid: gid }).then(
            data => {
              this.callingInfo.person = data || {}
            }
          )
        }).catch(() => { })
      })
    },
    goOlderDetail() {
      this.$router.push({
        path: "men/olderList/detail"
      });
      const temp = {
        theOldGid: this.callingInfo.person.gid,
        theOldName: this.callingInfo.person.name,
        status: this.callingInfo.status,
        theOldPhone: this.callingInfo.phone
      };
      this.$store.commit("SET_ONEOLDER", temp);
    },
    handleDetail(index, row) {
      this.routeTo({ path: '/orders/service/detail', query: { gid: row.gid } })
    },
  },
  mounted() {
    // this.loadData()
    console.log("mounted:" + JSON.stringify(this.phoneContactOlder));
  }
}
</script>
<style  scoped>
.goOlder {
  cursor: pointer;
  font-weight: bold;
  color: #67c23a;
}
</style>
